import { render, staticRenderFns } from "./AamsDocumentRegDispatchInfo.vue?vue&type=template&id=53055298&scoped=true&"
import script from "./AamsDocumentRegDispatchInfo.vue?vue&type=script&lang=js&"
export * from "./AamsDocumentRegDispatchInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53055298",
  null
  
)

export default component.exports